module.exports = __webpack_public_path__ + "img/logo-anima.71940cf0.svg";